import { apiTmx, refreshTmxToken } from '../api-config';

export interface TmXParams {
  TokenKey: string;
  CdAgent: string;
}
refreshTmxToken();

export const getCofre = async (TokenKey: string, CdAgent: string) => apiTmx
  .get(`api/geoid/territoryByAgentId?tokenKey=${TokenKey}&agentId=${CdAgent}`, { headers: { Authorization: sessionStorage.getItem('chave')?.toString() } })
  .then((resp) => resp.data.objectResult)
  .catch(async (error) => {
    if (error.response.status === 401) {
      return getCofre;
    }
    return [];
  });
